import sdl from '@jds/react-generated-sdl/JDSToastContainer';
import type { JDSToastContainerProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSToastContainerProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSToastContainer',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const ToastContainer = withLogic(
  Component
) as React.FC<JDSToastContainerProps> & { slotName?: string };

ToastContainer.displayName = 'ToastContainer';
ToastContainer.slotName = 'jds_toast_container';

export { ToastContainer, type JDSToastContainerProps };
